function returnOptions(data) {
  // 会员列表
  const memberCountList = data.map((item) => ({
    value: item.memberCount,
    name: item.typeName,
  }));
  // 散客列表
  const noMemberCountList = data.map((item) => ({
    value: item.noMemberCount,
    name: item.typeName,
  }));
  // 计算总和
  const arr = [];
  data.map((item) => arr.push(item.memberCount, item.noMemberCount));
  let sum = 0;
  for (let i = 0; i < arr.length; i++) {
    sum += arr[i];
  }
  // 总人数
  return {
    color: ['#20a0ff', ' #fe6d6c', '#fdd451'],
    graphic: [{
      type: 'text',
      left: '27.5%',
      top: '58%',
      style: {
        text: '会员',
        textAlign: 'center',
        fill: '#000',
        fontSize: 18,
        color: '#4d4f5c',
      }
    }, {
      type: 'text',
      left: '67.5%',
      top: '58%',
      style: {
        text: '散客',
        textAlign: 'center',
        fill: '#000',
        fontSize: 18,
      }
    },
    ],
    title: {
      show: true,
      text: '顾客来源统计',
      subtext: `顾客总人数：${sum}`,
    },
    legend: {
      orient: 'vertical',
      left: 'right',
    },
    // 自定义提示框浮层
    tooltip: {
      trigger: 'item',
      formatter: '{b} : {c} <br/>占比：{d}%'
    },
    series: [{
      type: 'pie',
      center: ['30%', '60%'],
      radius: ['30%', '70%'],
      avoidLabelOverlap: false,
      label: {
        // 饼图图形上的文本标签
        normal: {
          show: true,
          position: 'inner', // 标签的位置
          textStyle: {
            fontWeight: 300,
            fontSize: 12, // 文字的字体大小
            color: '#fff',
          },
          formatter: '{d}%',
        },
      },

      labelLine: {
        show: false
      },
      // 会员
      data: memberCountList
    },
    {
      type: 'pie',
      center: ['70%', '60%'],
      radius: ['30%', '70%'],
      avoidLabelOverlap: false,
      label: {
        // 饼图图形上的文本标签
        normal: {
          show: true,
          position: 'inner', // 标签的位置
          textStyle: {
            fontWeight: 300,
            fontSize: 12, // 文字的字体大小
            color: '#fff',
          },
          formatter: '{d}%',
        },
      },
      labelLine: {
        show: false
      },
      data: noMemberCountList
    },
    ]
  };
}
export const echartsE = returnOptions;

// const obj = memberCountList.map((item, index) => ({ ...item, ...noMemberCountList[index] }));
// console.log('3333', obj);
// // const arr = data.map((item) => ({
// //   value: item.noMemberCount,
// //   name: item.typeName,
// // }));
// // let obj = {        0: 'nihao',        1: 'haha',        2: 'gansha',
// //   }
// //   let arr = Object.values(obj)
// //   console.log(arr);
